<tokens-browser-start [allowDigipas]="allowDigipas" [browserName]="browserName" (next)="onNext()" (back)="onBack()"> </tokens-browser-start>
